import { Components, Theme } from '@mui/material/styles';

export const MuiPopover: Components<Theme>['MuiPopover'] = {
  styleOverrides: {
    paper: {
      backgroundColor: 'var(--palette-background-default)',
    },
  },
};
